import Box from '@gogame/ui/Box';
import Typography from '@gogame/ui/Typography';

import PieValueFormatter from './PieValueFormatter';

const PieTooltipContent = ({ payload, active, labelType }) => {
  if (active) {
    const { name, value, payload: cellPayload } = payload[0];
    const { formatter, percentValue } = cellPayload;

    return (
      <Box
        bgcolor={'common.white'}
        py={1}
        px={2}
        display={'flex'}
        boxShadow={3}
        alignItems={'center'}
      >
        <Box mr={2} alignItems={'center'} display={'flex'}>
          <svg width={'16'} height={'16'}>
            <rect width={'16'} height={'16'} fill={cellPayload.fill} />
          </svg>
        </Box>
        <Typography noWrap={true}>
          {name} -{' '}
          <PieValueFormatter
            value={value}
            formatter={formatter}
            percent={percentValue}
            labelType={labelType}
          />
        </Typography>
      </Box>
    );
  }
  return null;
};

export default PieTooltipContent;
